








































































import { DictBizServiceProxy } from "@/service-proxies/app-v2/system.service-proxies";
import { columns } from "./childColumn";
import Add from "./create.vue";
const service = new DictBizServiceProxy();
const options = {
  listApi: service.childList.bind(service),
  deleteApi: service.remove.bind(service),
};
export default {
  components: { Add },
  computed: {
    columns() {
      return columns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title),
        };
      }); // 表单配置
    },
    rowSelection() {
      const { selectedRowKeys }: any = this;
      return {
        selectedRowKeys,
        onChange: (selectedRowKeys: any) => {
          this.selectedRowKeys = selectedRowKeys;
        },
      };
    },
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    form: Object,
  },
  data() {
    return {
      ...options,
      createDialog: false,
      selectedRowKeys: [],
      Rowkey: "", // 所选表单行
      dataSource: [], // 列表数据
      totalContent: 0, // 总数
      query: {
        code: "",
        dictValue: "",
        parentId: "",
      },
      childForm: {
        code: "", // 字典编号
        dictValue: "", //字典名称
        sort: "", // 字典排序
        isSealed: 0, // 封存
        isSelected: false,
        remark: "", // 字典备注
        parentId: 0,
        parentValue: '',
      },
    };
  },
  created() {
    console.log(this.form, this.query, this.childForm);
    this.query.parentId = this.form.id;
    this.getList();
  },
  methods: {
    cancel() {
      this.$emit("close");
    },
    handleCreate() {
      this.createDialog = true;
      this.childForm = {
        code: this.form.code,
        dictValue: "",
        sort: "",
        isSealed: 0,
        isSelected: false,
        remark: "",
        parentId: this.form.id,
        parentValue: this.form.dictValue,
      };
      
    },
    handleSearch() {
      this.query.current = 1;
      this.getList();
    },
    handleDelete() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      let that = this;
      let ids = "";
      if (this.selectedRowKeys.length) {
        ids = this.selectedRowKeys.join(",");
      } else {
        ids = this.selectedRowKeys[0];
      }
      this.$confirm({
        content: "是否确定删除",
        onOk() {
          that.deleteApi(ids).then((res) => {
            that.selectedRowKeys = [];
            that.$message.success(that.$t("delete_success"));
            that.getList();
          });
        },
      });
    },
    handleUpdate() {
      this.createDialog = false;
      this.getList();
    },
    handleEdit(data) {
      let item = Object.assign({}, data);
      item.isSelected = item.isSealed ? true : false;
      item.parentValue = this.form.dictValue;
      this.childForm = item;
      this.createDialog = true;
    },
    async getList() {
      const res = await this.listApi(
        this.query.code,
        this.query.dictValue,
        this.query.parentId
      );
      const { data } = res;
      if (data.length) {
        this.dataSource = data;
      } else {
        this.dataSource = [];
      }
    },
  },
};
